import React from 'react';

import { InfoPage } from 'apps/auth/components/common/Layout/InfoPage/InfoPage';
import { AUTH_PLUS_MAIN_PAGE } from 'apps/auth/constants/UrlConstants';
import { usePageMessages } from 'apps/auth/hooks/selectors';

const Waiting = () => {
    const { headerTitle, statusDoneTitle } = usePageMessages();

    const renderScreen = () => {
        return (
            <InfoPage
                animatedIconSuccess
                hasBorder={false}
                mainText={headerTitle}
                buttonRowCaption={null}
                primaryButtonCaption={statusDoneTitle}
                primaryButtonType="link"
                primaryButtonLink={AUTH_PLUS_MAIN_PAGE}
            />
        );
    };
    return renderScreen();
};

export default Waiting;
